<template>
  <div class="navbar-header-model">
    <tabs v-model="selectedTab">
      <tab
        :style="`width:${100 / tabs.length}%`"
        v-for="(tab, i) in tabs"
        :key="`t${i}`"
        :val="tab.name"
        :label="tab.name"
        :indicator="true"
      />
    </tabs>
    <tab-panels v-model="selectedTab" :animate="true" :swipeable="true">
      <tab-panel v-for="(tab, i) in tabs" :key="`tp${i}`" :val="tab.name">
        <div class="row">
          <div v-for="(part, i) in tab.lives" :key="i" class="px-2 pt-3">
            <div
              :ref="'select-' + i"
              :class="i == videosIndex ? 'card-box rounded-pill' : 'card-box-block rounded-pill'"
            >
              <div
                @click="$emit('changeResolution', i)"
                :ref="'name-' + i"
                :class="i == videosIndex ? 'part-name' : 'part-name-block'"
              >
                {{ part.name }}
              </div>
            </div>
          </div>
        </div>
      </tab-panel>
    </tab-panels>
    <hr />
  </div>
</template>
<script lang="ts">
  import { isMobile } from 'views/shared/utils/mobile'
  import { defineComponent } from 'vue'
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs'
  export default defineComponent({
    name: 'NavBarPartsLiveMobile',
    components: {
      Tabs,
      Tab,
      TabPanels,
      TabPanel
    },
    props: ['parts', 'translate', 'videosIndex'],
    emits: ['changeResolution'],
    watch: {
      tabs: function (value) {
        this.selectedTab = value[0].name
      },
      videosIndex: function (value) {
        const divs = document.querySelectorAll('.card-box')
        divs.forEach((div) => {
          div.classList.remove('card-box')
          div.classList.add('card-box-block')
        })
        const divsName = document.querySelectorAll('.part-name')
        divsName.forEach((div) => {
          div.classList.remove('part-name')
          div.classList.add('part-name-block')
        })
        this.$refs[`select-${value}`].classList = 'card-box rounded-pill'
        this.$refs[`name-${value}`].classList = 'part-name'
      }
    },
    created() {
      this.tabs = this.parts
    },
    data() {
      return {
        selectedTab: 0,
        isMobile: isMobile(),
        tabs: []
      }
    }
  })
</script>
<style scoped>
  .tabs >>> .tab {
    padding: 15px 7px;
    font-weight: bold;
    font-size: 13px;
  }
  .tab-panels >>> .tab-panel {
    width: 98%;
  }
  .navbar-header-model .tabs > .active {
    color: #b20000;
    border-color: #b20000;
    background-color: #fafafa;
  }

  .button--more svg {
    color: #b20000;
  }

  .button--more {
    font-family: 'Exo-2';
    font-weight: bold;
    color: #898989;
    font-size: 16px;
  }

  .small svg {
    margin-right: 5px;
  }

  .card-box {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border: 1px solid #cccccc;
  }

  .card-box-block {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #cccccc;
    background-color: #f0f0f0;
  }

  .part-name {
    font-size: 16px;
    color: #b20000;
    font-family: 'Exo-2';
    font-weight: 900;
  }

  .part-name-block {
    font-size: 16px;
    color: #000000;
    font-family: 'Exo-2';
    padding-top: 2px;
    font-weight: 700;
  }

  .fa-lock {
    color: #b20000;
  }
  .disable {
    cursor: not-allowed;
  }
</style>
